import React from 'react';
import { FC210, FC213 } from '../../../services/c212Api';

interface Tab3Props {
  formData: Partial<FC210>;
  attachments: Partial<FC213>[];
  selectedAttachRow: number;
  isEditing: boolean;
  getField: (key: keyof FC210) => FC210[keyof FC210];
  setField: (key: keyof FC210, value: FC210[keyof FC210]) => void;
  setAttachments: React.Dispatch<React.SetStateAction<Partial<FC213>[]>>;
  setSelectedAttachRow: (idx: number) => void;
  addAttachRow: () => void;
  deleteAttachRow: () => void;
}

/** Tab3: Page3 備註/附件 */
const Tab3Attachments: React.FC<Tab3Props> = React.memo(({
  formData, attachments, selectedAttachRow, isEditing,
  getField, setField, setAttachments, setSelectedAttachRow,
  addAttachRow, deleteAttachRow,
}) => {
  const handleAttachChange = (idx: number, key: keyof FC213, value: FC213[keyof FC213]) => {
    setAttachments(prev => prev.map((a, i) => i === idx ? { ...a, [key]: value } : a));
  };

  // Approved = read-only for attachments (but upload col enabled in FoxPro)
  const approved = (formData.fc210_80 || '').trim() === 'P';

  return (
    <div className="tab-content-section">
      {/* Memo (editbox) */}
      <div className="memo-group">
        <label>備註</label>
        <textarea rows={4} style={{ width: '100%' }}
          value={String(getField('fc210_32') || '')}
          onChange={e => setField('fc210_32', e.target.value)}
          disabled={!isEditing} />
      </div>

      {/* Attachment Grid (FC213) */}
      <div className="grid-header">
        <h3 className="section-title" style={{ marginBottom: 0 }}>附件</h3>
        <div className="grid-actions">
          <button className="btn btn-sm" disabled={!isEditing} onClick={addAttachRow}>附件新增</button>
          <button className="btn btn-sm btn-danger"
            disabled={!isEditing || attachments.length === 0 || (approved && (attachments[selectedAttachRow]?.fc213_22 === 'P'))}
            onClick={deleteAttachRow}>附件刪除</button>
        </div>
      </div>
      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th style={{ width: 40 }}>項次</th>
              <th>附件名稱</th>
              <th style={{ width: 100 }}>檔案類型</th>
            </tr>
          </thead>
          <tbody>
            {attachments.length === 0 && (
              <tr><td colSpan={3} style={{ textAlign: 'center', color: '#999' }}>無附件資料</td></tr>
            )}
            {attachments.map((a, i) => (
              <tr key={i}
                className={i === selectedAttachRow ? 'row-selected' : ''}
                onClick={() => setSelectedAttachRow(i)}>
                <td>{a.fc213_02}</td>
                <td>
                  <input type="text" value={a.fc213_11 || ''} disabled={!isEditing}
                    onChange={e => handleAttachChange(i, 'fc213_11', e.target.value)} />
                </td>
                <td>
                  <select value={a.fc213_21 ?? ''} disabled={!isEditing}
                    onChange={e => handleAttachChange(i, 'fc213_21', parseInt(e.target.value, 10) || 0)}>
                    <option value="">--</option>
                    <option value={1}>EML</option>
                    <option value={2}>DOC</option>
                    <option value={3}>XLS</option>
                    <option value={4}>PPT</option>
                    <option value={5}>HTM</option>
                    <option value={6}>PDF</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
});

Tab3Attachments.displayName = 'Tab3Attachments';
export default Tab3Attachments;
